import React from 'react'

import TasksKanbanBoard from 'components_new/organisms/tasks/TasksKanbanBoard'

import PageLayout from 'components_new/templates/PageLayout'

import { useTranslation } from 'language/translator'

const Tasks = () => {
  const { t } = useTranslation()

  return (
    <PageLayout
      footer={{
        mobile: {
          showNavigation: true
        }
      }}
      topbar={{
        breadcrumbs: [
          {
            icon: { name: 'Tasks' },
            title: t('tasks', 'tasks')
          }
        ]
      }}
      variant="static"
    >
      <TasksKanbanBoard />
    </PageLayout>
  )
}

export default Tasks
